export default __webpack_public_path__ + "static/media/822.6733a8e1.gif";